import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/grayscale.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                { name: 'description', content: 'Orestis Zafeiriou is an Athens based electronic music composer-sound artist, interested in the relation between sound and the ability of the brain to evoke diverse “images” of what is heard.' },
                { name: 'keywords', content: 'music, composers, sound, artist, composition, electronic, electroacoustic, installation'},
              ]}
            >
              <meta property="og:type" content="website"/>
              <meta property="og:url" content="https://www.orestiszafeiriou.com"/>
              <meta property="og:description" content="Orestis Zafeiriou is an Athens based electronic music composer-sound artist, interested in the relation between sound and the ability of the brain to evoke diverse “images” of what is heard." />
              <meta property="og:image" content="https://www.orestiszafeiriou.com/static/about-18861ba68f652e3dc243e775686030e5.jpg" />
              <html lang="en" />
            </Helmet>
            <div id="page-top" className={'page-top'} style={{background: 'black'}}>{children}</div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
